<template>
  <div>
    <form-wizard @on-complete="onComplete" @on-change="onChange" color="#26B4FF" ref="formWizard">
      <!-- Allow html in tab title (this template required for the proper styling) -->
      <template slot="step" slot-scope="props">
        <wizard-step
          :tab="props.tab"
          @click.native="props.navigateToTab(props.index)"
          @keyup.enter.native="props.navigateToTab(props.index)"
          :transition="props.transition"
          :index="props.index"
        >
          <span slot="title" :class="styleColor(props.tab)" v-html="props.tab.title"> </span>
        </wizard-step>
      </template>
      <slot name="tabs"> </slot>

      <!-- Buttons -->
      <template slot="footer">
        <b-btn variant="secondary" @click="prevTab" :disabled="isLoading || !isSubmitting"
          ><font-awesome-icon v-if="iconButton" :icon="['fas', 'chevron-left']" />{{ $t('Voltar') }}</b-btn
        >
        <b-btn variant="primary" @click="nextTab" v-if="isLastStep" :disabled="isLoading || !isSubmitting">{{
          $t('Confirmar')
        }}</b-btn>
        <b-btn v-else variant="primary" @click="nextTab" :disabled="isLoading || !isSubmitting"
          >{{ $t('Próximo') }} <font-awesome-icon v-if="iconButton" :icon="['fas', 'chevron-right']"
        /></b-btn>
      </template>
    </form-wizard>
  </div>
</template>

<style src="@/vendor/libs/vue-form-wizard/vue-form-wizard.scss" lang="scss"></style>

<script>
import { FormWizard, WizardStep } from 'vue-form-wizard';

export default {
  components: {
    FormWizard,
    WizardStep
  },
  props: { iconButton: true, isLoading: false, isSubmitting: true },
  data() {
    return {
      isLastStep: false
    };
  },
  mounted() {
    this.checkIsLastStep();
  },
  methods: {
    onComplete() {
      this.$emit('onSave');
    },
    styleColor(tab) {
      if (tab.validationError) {
        return 'text-danger';
      } else {
        if (tab.active) {
          return 'text-primary';
        } else {
          return !tab.checked ? 'text-primary' : 'text-primary';
        }
      }
    },
    onChange(prevIndex, nextIndex) {
      this.checkIsLastStep();
    },
    checkIsLastStep() {
      if (this.$refs.formWizard) {
        this.$nextTick(() => {
          if (this.$refs.formWizard && this.$refs.formWizard.isLastStep !== undefined) {
            this.isLastStep = this.$refs.formWizard.isLastStep;
          }
        });
      }
    },
    prevTab() {
      if (this.$refs.formWizard.activeTabIndex === 0) {
        this.$emit('onBack');
      } else {
        this.$refs.formWizard.prevTab();
      }
    },
    nextTab() {
      this.$refs.formWizard.nextTab();
    }
  }
};
</script>
